<nav [attr.aria-label]="navAriaLabel">
    <ul [attr.role]="
      flyout && (node?.children?.length ?? 0) > 1 ? 'list' : 'presentation'
    ">
    @if (flyout && (node?.children?.length ?? 0) > 1) {
      <li class="back is-open">
        <button (click)="back()">
          <cx-icon [type]="iconType.CARET_LEFT"></cx-icon>
          {{ 'common.back' | cxTranslate }}
        </button>
      </li>
    }

    @for (child of node?.children; track child) {
      <ng-container *ngTemplateOutlet="nav; context: { node: child, depth: 0 }">
      </ng-container>
    }
  </ul>
</nav>
<!-- we generate links in a recursive manner -->

<ng-template #nav let-node="node" let-depth="depth" let-listLength="listLength" let-position="position">
  <li [attr.role]="!flyout && !depth ? 'presentation' : 'listitem'">
    <ng-container>
      @if (
        node.url && (!node.children || node.children?.length === 0)) {
<cx-generic-link [ariaLabel]="
          'navigation.linkItemInList'
            | cxTranslate
              : {
                  title: node.title,
                  position,
                  listLength,
                }
        " [url]="node.url" [target]="node.target" [style]="node.styleAttributes" [class]="node.styleClasses"
        (click)="closeIfClickedTheSameLink(node)" [tabindex]="getTabIndex(node, depth)"
        (focus)="depth || reinitializeMenu()" (keydown.space)="toggleOpen($any($event))" (keydown.esc)="back()">
        {{ node.title }}
      </cx-generic-link>
    } @else {
      @if (flyout && node.children?.length > 0) {
        @if (node.url) {
          <cx-generic-link [url]="node.url" [target]="node.target"
            (click)="closeIfClickedTheSameLink(node)">
            <span class="parent-icon">
              {{ node.title }}
              @if (depth === 0) {
                <cx-icon [type]="iconType.CARET_DOWN"></cx-icon>
              }
              @if (depth > 0) {
                <cx-icon [type]="iconType.CARET_RIGHT" class="small"></cx-icon>
              }
            </span>
          </cx-generic-link>
        }
        <button [attr.role]="(isDesktop$ | async) && depth ? 'heading' : 'button'" [attr.aria-haspopup]="true"
          [attr.aria-expanded]="false" [attr.aria-label]="getAriaLabelAndControl(node)"
          [attr.aria-controls]="getAriaLabelAndControl(node)" (click)="toggleOpen($any($event))"
          (mouseenter)="onMouseEnter($event)" (keydown.space)="onSpace($any($event))"
          (keydown.enter)="onSpace($any($event))" (keydown.esc)="back()"
          (keydown.arrowDown)="focusOnNode($any($event))" (focus)="depth || reinitializeMenu()">
          @if (!node.url) {
            {{ node.title }}
          }
        </button>
      } @else {
        @if (node.title) {
          <span role="heading" aria-level="4" [attr.tabindex]="focusableNodeTitles ? 0 : -1">
            {{ node.title }}
          </span>
        }
      }
    }
  </ng-container>


  <!-- we add a wrapper to allow for better layout handling in CSS -->
  @if (node.children && node.children.length > 0) {
    <div [id]="getSanitizedTitle(node.title)" class="wrapper wrapper-hide"
      >
      <ul class="childs" [attr.depth]="getTotalDepth(node)"
        [attr.wrap-after]="node.children.length > wrapAfter ? wrapAfter : null"
        [attr.columns]="getColumnCount(node.children.length)" [attr.aria-label]="node.title">
        @for (child of node.children| sort:'title'; track child; let i = $index) {
                    <ng-container *ngTemplateOutlet="
              nav;
              context: {
                node: child,
                depth: depth + 1,
                listLength: node.children.length,
                position: i + 1,
              }
            ">
        </ng-container>
      }
    </ul>
  </div>
}
</li>
</ng-template>
